<template>
	<section>
		<div class="cookie-popup-container">
			<div class="cookie-popup">
				<focus-lock :return-focus="true">
					<h1>{{ appName }} Cookies</h1>

					<p>We use cookies in order to improve the experience of Looped in. For more information, please check our <router-link to="/privacy-policy">Privacy Policy</router-link></p>

					<button @click="accept">Accept Cookies</button>

					<div>
						<div class="cookie-popup__section">
							<h2>Required Cookies</h2>
							<p class="cookie-popup__section-text">Certain cookies will be required in order for this site to function.</p>
						</div>
						<div class="cookie-popup__section">
							<h2>Analytics Cookies</h2>
							<p class="cookie-popup__section-text">We use Google Analytics in order to improve the user experience of this site. If you’d like to opt out of being tracked, please check the option below.</p>
							<fieldset>
								<div class="radio">
									<input
										type="radio"
										id="analytics-on"
										name="analytics-toggle"
										value="on"
										v-model="analytics"
										checked
									>
									<label
										for="analytics-on"
										class="radio__label"
									>
										On
									</label>
								</div>

								<div class="radio">
									<input
										type="radio"
										id="analytics-off"
										name="analytics-toggle"
										value="off"
										v-model="analytics"
									>
									<label
										for="analytics-off"
										class="radio__label"
									>
										Off
									</label>
								</div>
							</fieldset>
						</div>
					</div>
				</focus-lock>
			</div>
		</div>
		<div class="overlay"></div>
	</section>
</template>

<script>
// Components
import FocusLock from 'vue-focus-lock';

export default {
	components: {
		FocusLock
	},
	data() {
		return {
			appName: process.env.VUE_APP_NAME,
			analytics: (localStorage.getItem('analytics-cookies') !== null && localStorage.getItem('analytics-cookies') !== 'null') ? localStorage.getItem('analytics-cookies') : 'on'
		};
	},
	methods: {
		accept() {
			this.$store.dispatch('updateAnalyticsCookies', this.analytics);
			window.location.reload();
		}
	}
};
</script>

<style lang="scss" scoped>
$dark-color: #333;

* {
	color: $dark-color;
	font-size: 18px;
	line-height: 1.4;
}

a {

	&:hover,
	&:focus {
		text-decoration: none;
	}
}

button {
	background-color: $dark-color;
	border: 0;
	border-radius: 0;
	color: #FFF;
	margin-bottom: 20px;

	&:hover,
	&:focus {
		background-color: #555;
	}
}

h1 {
	font-size: 36px;
}

fieldset {
	margin-top: 10px;
}

section {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 9999;

	@media print {
		display: none;
	}
}

.cookie-popup-container {
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	position: fixed;
	z-index: 2;
}

.cookie-popup {
	background-color: #FFF;
	color: $dark-color;
	font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	font-weight: 400;
	margin: 0 auto;
	max-width: 600px;
	max-height: 680px;
	overflow-y: auto;
	padding: 20px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(calc(-50% - .5px));
	width: 100%;
	height: 100%;

	@media screen and (max-width: 767px) {
		max-width: 100%;
		max-height: 100%;
	}

	a {

		&:focus {
			text-decoration: underline;
		}
	}

	&__section {
		border-top: 1px solid $dark-color;
		padding: 20px 0;

		&:last-child {
			padding-bottom: 0;
		}
	}

	&__section-text {
		margin: 0;
	}
}

.radio {
	margin-bottom: 5px;

	&:last-child {
		margin-bottom: 0;
	}

	&__label {
		line-height: 1.1;
	}
}

.overlay {
	background-color: rgba(0, 0, 0, 0.71);
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
}
</style>
